import { __assign, __rest } from "tslib";
import React, { useRef, useImperativeHandle } from "react";
import classNames from "classnames";
import { Input } from "../input";
import { Button } from "../button";
import { useDefaultValue } from "../form/controlled";
import { ScaleTransition } from "../transition";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { noop } from "../_util/noop";
import { KeyMap } from "../_util/key-map";
import { callBoth } from "../_util/call-both";
import { mergeRefs } from "../util";
export var SearchBox = forwardRefWithStatics(function SearchBox(props, ref) {
    var _a, _b;
    var classPrefix = useConfig().classPrefix;
    var multiline = props.multiline, simple = props.simple, _c = props.onSearch, onSearch = _c === void 0 ? noop : _c, _d = props.onClear, onClear = _d === void 0 ? noop : _d, className = props.className, style = props.style, size = props.size, showHelp = props.showHelp, disabled = props.disabled, _e = props.onHelp, onHelp = _e === void 0 ? noop : _e, searchBoxRef = props.searchBoxRef, _inputProps = __rest(props, ["multiline", "simple", "onSearch", "onClear", "className", "style", "size", "showHelp", "disabled", "onHelp", "searchBoxRef"]);
    var inputBoxClassNames = classNames((_a = {},
        _a[classPrefix + "-search"] = true,
        _a[classPrefix + "-search--multi"] = multiline,
        _a[classPrefix + "-search--simple"] = simple,
        _a[className] = className,
        _a));
    var inputProps = useDefaultValue(_inputProps, "");
    var composingRef = useRef(null);
    // 需要使用到 inputRef，同时向外部暴露
    var inputRef = useRef(null);
    useImperativeHandle(ref, function () { return inputRef.current; });
    return (React.createElement("div", { className: classNames(classPrefix + "-form--search", (_b = {},
            _b[classPrefix + "-search--has-info"] = showHelp,
            _b["size-" + (size === "full" ? size + "-width" : size)] = size,
            _b)), ref: mergeRefs(searchBoxRef) },
        React.createElement("div", { className: inputBoxClassNames, style: style },
            React.createElement("div", { className: classPrefix + "-search__inner" },
                React.createElement(Input, __assign({ type: "search", disabled: disabled, multiline: multiline, baseClassName: classPrefix + "-input", className: classPrefix + "-input--search", onKeyDown: function (event) {
                        var key = event.key, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        if (key === KeyMap.Esc) {
                            event.preventDefault();
                            inputProps.onChange("", { event: event });
                            onClear();
                        }
                        // 回车处理 onSearch 逻辑
                        if (key !== KeyMap.Enter) {
                            return;
                        }
                        // 多行模式下，要按下 ctrl 或者 command
                        if (multiline && !metaKey && !ctrlKey) {
                            return;
                        }
                        event.preventDefault();
                        if (!composingRef.current) {
                            onSearch(event.currentTarget.value, { event: event });
                        }
                    } }, inputProps, { onCompositionStart: callBoth(function () {
                        composingRef.current = true;
                    }, inputProps.onCompositionStart), onCompositionEnd: callBoth(function () {
                        composingRef.current = false;
                    }, inputProps.onCompositionEnd), ref: inputRef }))),
            React.createElement(ScaleTransition, { in: /\S/.test(inputProps.value) },
                React.createElement(Button, { icon: "dismiss", htmlType: "button", disabled: disabled, className: classPrefix + "-btn--dismiss", onClick: function (event) {
                        event.preventDefault();
                        inputProps.onChange("", { event: event });
                        onClear();
                        if (inputRef.current) {
                            inputRef.current.focus();
                        }
                    } })),
            showHelp && (React.createElement(Button, { icon: "info", htmlType: "button", disabled: disabled, className: classPrefix + "-btn--info", onClick: onHelp })),
            React.createElement(Button, { icon: "search", htmlType: "button", disabled: disabled, className: classPrefix + "-btn--search", onClick: function (event) {
                    event.preventDefault();
                    onSearch(inputProps.value, { event: event });
                } }))));
}, {
    defaultLabelAlign: "middle",
});
SearchBox.displayName = "SearchBox";
//# sourceMappingURL=SearchBox.js.map